import React, { useState, useEffect, useRef } from 'react';
import Rnd from 'react-rnd';
import { makeStyles } from '@material-ui/core/styles';
import NormalTooltip from '../../styles/tooltip';
import {
  ACTION_TYPE,
  ACTION_TYPE_FLYER_SALES,
  USER_LEVEL_NO,
  GUIDANCE_STATUS_CODE,
} from '../../../constants';
// eslint-disable-next-line import/no-cycle
import InfoRegisterOnlyPost from '../../common/infoRegisterOnlyPost';
import EditableWindow from '../../pages/actRegist/editableWindow';
import ActRegistWindow from '../../pages/actRegist/actRegistWindow';
import { useActionSchedule } from '../../../containers/actionSchedule/actionScheduleContext';
import { dateFormatter } from '../../../commonFunction';
import store from '../../../store';

const useStyles = makeStyles((theme) => ({
  rnd: {
    position: 'relative',
    border: '1px solid #C8C8C8',
    background: '#fff',
    borderRadius: '0 4px 4px 4px',
    overflow: 'hidden',
    display: 'flex!important',
    flexWrap: 'nowrap',
    alignItems: 'center',
    padding: '5px 0',
    '&.single': {
      flexWrap: 'wrap',
      '& > span:first-child': {
        width: '100%',
      },
    },
    '&::before': {
      content: '""',
      display: 'block',
      width: 0,
      height: 0,
      borderWidth: '14px 14px 0 0',
      borderStyle: 'solid',
      position: 'absolute',
      top: 0,
      left: 0,
      borderColor: 'transparent',
    },
    '&.actionScheduleCode-1::before': {
      borderColor: '#64CAF5 transparent transparent',
    },
    '&.actionScheduleCode-2::before': {
      borderColor: '#64CAF5 transparent transparent',
    },
    '&.actionScheduleCode-3::before': {
      borderColor: `${theme.palette.primaryColor} transparent transparent`,
    },
    '&.actionScheduleCode-4::before': {
      borderColor: '#F2994A transparent transparent',
    },
    '&.actionScheduleCode-5::before': {
      borderColor: '#DEDEDE transparent transparent',
    },
    '&.actionScheduleCode-6::before': {
      borderColor: '#64CAF5 transparent transparent',
    },
    '&.actionScheduleCode-7::before': {
      borderColor: '#64CAF5 transparent transparent',
    },
    '&.actionScheduleCode-999': {
      background: '#FCE034',
      '&::before': {
        borderColor: 'transparent',
      },
      '&.isResultRegister-1::before': {
        borderColor: '#D83420 transparent transparent',
      },
      '&.customerStatusCode-10::before': {
        borderColor: '#27AE60 transparent transparent',
      },
    },
  },
  txt1: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    lineHeight: '1.2',
    letterSpacing: '0',
    display: 'block',
    padding: '0 0 0 8px',
    whiteSpace: 'nowrap',
    width: 'auto',
  },
  txt2: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    lineHeight: '1.2',
    letterSpacing: '0',
    display: 'block',
    padding: '0 0 0 8px',
    whiteSpace: 'nowrap',
  },
}));

export default function DayRnd(props) {
  const {
    item,
    index,
    rndHeightList,
    localUpdateData,
    setLocalUpdateData,
    setOpenCustomertree,
  } = props;

  const {
    getSchedulesDate,
    setReacquisitionFlg,
    functions,
    selectDivision,
  } = useActionSchedule();

  const classes = useStyles();

  // クリックとドラッグの制御
  const [dragging, setDragging] = useState(false);

  // GA004モーダルの開閉
  const [open2, setOpen2] = useState(false);
  // OH_KDSFA-2329 範囲外移動後の案内日時
  const [guidanceAtValues, setGuidanceAtValues] = useState(null);
  const onClose2 = () => {
    setOpen2(false);
    setGuidanceAtValues(null);
    // 再取得
    getSchedulesDate();
  };

  // GA-108 行動登録画面
  // OH_KDSFA-2329 範囲外移動後の編集用日時
  const [actRegistValues, setActRegistValues] = useState(null);
  const [editableOpen, setEditableOpen] = useState(false);
  const onCloseEditable = () => {
    setEditableOpen(false);
    setActRegistValues(null);
    // 再取得
    getSchedulesDate();
  };
  const [openActRegist, setOpenActRegist] = useState(false);
  const onCloseActRegist = () => {
    setOpenActRegist(false);
    setActRegistValues(null);
    // 再取得
    getSchedulesDate();
  };
  // 目標
  const [targetObj, setTargetObj] = useState({
    targetTotalCard: '',
    targetSearchCard: '',
    targetTelAppoint: '',
    targetGuidance: '',
    targetImmediateGuidance: '',
    targetVisit: '',
  });
  // 実績
  const [archieveObj, setArchieveObj] = useState({
    archieveTotalCard: '',
    archieveSearchCard: '',
    archieveTelAppoint: '',
    archieveGuidance: '',
    archieveImmediateGuidance: '',
    archieveVisit: '',
  });
  const [actRegistSelectDivision, setActRegistSelectDivision] = useState(selectDivision);

  // 時と分に分割
  let startHour = item.startAt;
  let endHour = item.endAt;
  let startMin = item.startAt;
  let endMin = item.endAt;
  if (startHour) {
    startHour = startHour.substr(11, 2);
  }
  if (endHour) {
    endHour = endHour.substr(11, 2);
  }
  if (startMin) {
    startMin = startMin.substr(14, 2);
  }
  if (endMin) {
    endMin = endMin.substr(14, 2);
  }

  // 日付に変換
  const startDate = new Date(item.startAt);
  const endDate = new Date(item.endAt);

  // 開始時刻
  const [hourS, setHourS] = useState(startHour);
  const [minutesS, setMinutesS] = useState(startMin);
  // 終了時刻
  const [hourE, setHourE] = useState(endHour);
  const [minutesE, setMinutesE] = useState(endMin);
  // 合計時間
  const [sum, setSum] = useState((endDate.getTime() - startDate.getTime()) / (60 * 1000));
  // 1セルの幅（30分）
  const cellSize = 56;
  // OH_KDSFA-2329 21:00以降の予定を表示する領域を含む全セルの幅
  const cellSizeAll = 1456;
  // ラベルの幅 開始位置 X
  let rndWidthInitial = (sum / 30) * cellSize;
  let startXInitial = ((((startHour - 9) + (startMin / 60)) * 2) + 1) * cellSize;
  const endXInitial = startXInitial + rndWidthInitial;

  // 開始時間が～9:00 or 終了時間が21:00～ 範囲外かどうかの判定
  const outsideFlg = useRef(false);

  if (item.startAt.substr(0, 10) !== item.endAt.substr(0, 10)) { // 日付を跨ぐ場合
    if (startHour < 9) { // 開始時間が～9:00
      startXInitial = 0;
      rndWidthInitial = cellSizeAll;
    } else if (startHour > 20) { // 開始時間が21:00～
      startXInitial = 1400;
      rndWidthInitial = cellSize;
    } else {
      rndWidthInitial = cellSizeAll - startXInitial;
    }
    outsideFlg.current = true;
  } else if (startHour < 9) { // 開始時間が～9:00
    // OH_KDSFA-2329 9:00以前も実時間の幅を保ち、表示範囲を超える分だけ切り詰める
    startXInitial = Math.max(startXInitial, 0);
    rndWidthInitial = endXInitial <= 0
      ? cellSize
      : Math.max(
        cellSize / 2,
        Math.min(endXInitial, cellSizeAll) - startXInitial,
      );
    outsideFlg.current = true;
  } else if (startHour > 20) { // 開始時間が21:00～
    // OH_KDSFA-2329 21:00以降も実時間の幅を保ち、表示範囲を超える分だけ切り詰める
    if (startXInitial >= cellSizeAll) {
      startXInitial = cellSizeAll - cellSize;
      rndWidthInitial = cellSize;
    } else {
      rndWidthInitial = Math.max(
        cellSize / 2,
        Math.min(endXInitial, cellSizeAll) - startXInitial,
      );
    }
    outsideFlg.current = true;
  } else if (endHour > 20) { // 終了時間が21:00～
    // OH_KDSFA-2329 21:00以降は実時間の幅を保ち、表示範囲を超える分だけ切り詰める
    rndWidthInitial = Math.min(rndWidthInitial, cellSizeAll - startXInitial);
    if (endMin === '00') {
      outsideFlg.current = false;
    } else {
      outsideFlg.current = true;
    }
  }

  const [rndWidth, setRndWidth] = useState(rndWidthInitial);
  const [startX, setStartX] = useState(startXInitial);
  // 開始位置 Y
  const [startY, setStartY] = useState(rndHeightList[index].odr * 21);

  const [reset, setReset] = useState(false);

  useEffect(() => {
    if (item.startAt.substr(0, 10) !== item.endAt.substr(0, 10)) { // 日付を跨ぐ場合
      outsideFlg.current = true;
    } else if (startHour < 9) { // 開始時間が～9:00
      outsideFlg.current = true;
    } else if (startHour > 20) { // 開始時間が21:00～
      outsideFlg.current = true;
    } else if (endHour > 20) { // 終了時間が21:00～
      if (endMin === '00') {
        outsideFlg.current = false;
      } else {
        outsideFlg.current = true;
      }
    } else {
      outsideFlg.current = false;
    }
    setHourS(startHour);
    setMinutesS(startMin);
    setHourE(endHour);
    setMinutesE(endMin);
    setSum((endDate.getTime() - startDate.getTime()) / (60 * 1000));
    if (startHour > 9 && startHour < 21) {
      setStartX(((((startHour - 9) + (startMin / 60)) * 2) + 1) * cellSize);
    } else {
      setStartX(startXInitial);
    }
    setStartY(rndHeightList[index].odr * 21);
    setReset(!reset);
  }, [item]);

  useEffect(() => {
    if (item.startAt.substr(0, 10) !== item.endAt.substr(0, 10)) {
      setRndWidth(cellSizeAll - startX);
    } else if (startHour >= 9 && endHour > 20) {
      setRndWidth(Math.min(rndWidthInitial, cellSizeAll - startX));
    } else if (startHour < 9) {
      setRndWidth(rndWidthInitial);
    } else if (startHour > 20) {
      setRndWidth(cellSize);
    } else if (startHour >= 9 && endHour <= 20) {
      setRndWidth(rndWidthInitial);
    }
  }, [sum, reset]);

  const getMovedSchedule = (position, minutes) => {
    const start = new Date(item.startAt);
    start.setHours(9, 0, 0, 0);
    start.setMinutes(start.getMinutes() + Math.round((position / 112) * 60));
    const end = new Date(start);
    end.setMinutes(end.getMinutes() + minutes);

    return {
      startAt: dateFormatter(start),
      endAt: dateFormatter(end),
    };
  };

  // ラベルの更新制御
  const updateRndFlg = useRef(false);
  // OH_KDSFA-2329 操作終了時は停止イベントの座標ではなく、最後の移動日時で判定する
  const movedScheduleRef = useRef(null);
  const updateMovedSchedule = (position, minutes) => {
    const movedSchedule = getMovedSchedule(position, minutes);
    const endPosition = position + ((minutes / 30) * cellSize);
    // OH_KDSFA-2329 9:00未満または21:00超を範囲外として判定する
    const isOutside = position < 0 || position >= 1344 || endPosition > 1344;

    movedScheduleRef.current = {
      ...movedSchedule,
      isOutside,
    };
    outsideFlg.current = isOutside;
    updateRndFlg.current = !isOutside;
    setHourS(movedSchedule.startAt.substr(11, 2));
    setMinutesS(movedSchedule.startAt.substr(14, 2));
    setHourE(movedSchedule.endAt.substr(11, 2));
    setMinutesE(movedSchedule.endAt.substr(14, 2));
    setStartX(position + cellSize);

    if (!isOutside) {
      setReacquisitionFlg(true);
    }
  };

  // onResizeを実行しているのかどうかのFlg
  const [isDoingOnResize, setIsDoingOnResize] = useState(false);
  const onResize = async (e, direction, ref, delta, position) => {
    // 合計時間を取得
    const minutes = Math.floor(parseInt(ref.style.width, 10) / 28) * 15;
    setSum(Number(minutes));
    // 開始位置を取得
    const positionX = Math.round(position.x) - cellSize;
    setIsDoingOnResize(true);
    updateMovedSchedule(positionX, minutes);
  };

  // onDragを実行しているのかどうかのFlg
  const [isDoingOnDrag, setIsDoingOnDrag] = useState(false);
  const onDrag = async (e, d) => {
    // 開始位置を取得
    const positionX = Math.round(d.x) - 440;
    setIsDoingOnDrag(true);
    updateMovedSchedule(positionX, sum);
    // クリックとドラッグの制御
    setDragging(true);
  };

  const [count, setCount] = useState(0);

  // OH_KDSFA-2329 範囲外移動後の日時を各登録画面へ引き継ぐ
  const openOutsideEditWindow = async (movedSchedule) => {
    updateRndFlg.current = false;
    if (item.actionScheduleCode === null) {
      setGuidanceAtValues({
        guidanceStartAt: movedSchedule.startAt,
        guidanceEndAt: movedSchedule.endAt,
      });
      setOpen2(true);
      return;
    }

    await functions.getSchedulesDetailFunction(item.scheduleId);
    const scheduleDetail = store.getState()
      .schedulesGetActionDetail.schedulesGetActionDetail;
    if (ACTION_TYPE_FLYER_SALES.includes(item.actionScheduleCode)) {
      // OH_KDSFA-2329 源泉終了画面は元日時、編集画面は移動後日時を使用する
      setActRegistValues({
        ...scheduleDetail,
        startAt: movedSchedule.startAt,
        endAt: movedSchedule.endAt,
      });
      // OH_KDSFA-2329 API再取得で編集用日時を上書きしない
      setReacquisitionFlg(false);
      setEditableOpen(true);
      return;
    }

    setActRegistValues({
      ...scheduleDetail,
      startAt: movedSchedule.startAt,
      endAt: movedSchedule.endAt,
    });
    // OH_KDSFA-2329 更新API未実行時の再取得フラグを解除してから開く
    setReacquisitionFlg(false);
    setOpenActRegist(true);
  };

  const onResizeStop = async () => {
    const movedSchedule = movedScheduleRef.current;
    if (!movedSchedule) {
      return;
    }

    if (movedSchedule.isOutside) {
      await openOutsideEditWindow(movedSchedule);
      movedScheduleRef.current = null;
    } else {
      // 更新処理を呼び出す
      setCount((prev) => prev + 1);
    }
  };

  const onDragStop = async () => {
    const movedSchedule = movedScheduleRef.current;
    if (!movedSchedule) {
      return;
    }

    // クリックとドラッグの制御
    setTimeout(() => { setDragging(false); }, 500);
    if (movedSchedule.isOutside) {
      await openOutsideEditWindow(movedSchedule);
      movedScheduleRef.current = null;
    } else {
      // 更新処理を呼び出す
      setCount((prev) => prev + 1);
    }
  };

  useEffect(() => {
    // 更新可 かつ onDragまたはonResizeの実行時のみ更新処理を実行する
    if (updateRndFlg.current
      && movedScheduleRef.current
      && (isDoingOnDrag || isDoingOnResize)
    ) {
      // 更新
      const updateStartAt = movedScheduleRef.current.startAt;
      const updateEndAt = movedScheduleRef.current.endAt;
      if (item.actionScheduleCode) {
        functions.schedulesUpdateApiFunction(
          item.scheduleId,
          {
            startAt: updateStartAt,
            endAt: updateEndAt,
          },
        );
      } else {
        functions.putGuidanceByGuidanceIdFunction(
          item.guidanceId,
          {
            guidanceStartAt: updateStartAt,
            guidanceEndAt: updateEndAt,
            customerId: item.customerId,
            guidanceStatusCode: item.guidanceStatusCode,
            contactId: item.contactId,
            actionId: item.actionId,
            contactCode: item.contactCode,
          },
        );
      }
      movedScheduleRef.current = null;
    }
    // onDragの実行中Flgがtrueの場合は、falseとする
    if (isDoingOnDrag) {
      setIsDoingOnDrag(false);
    }
    // onResizeの実行中Flgがtrueの場合は、falseとする
    if (isDoingOnResize) {
      setIsDoingOnResize(false);
    }
  }, [count]);

  const onClick = async () => {
    if (dragging) return;
    // OH_KDSFA-2329 通常クリック時は範囲外移動後の日時を破棄する
    setActRegistValues(null);
    setGuidanceAtValues(null);
    // actionScheduleCodeがnullの場合、GA-004画面を開く
    if (item.actionScheduleCode === null) {
      setOpen2(true);
    } else {
      // グローバルステート(schedulesGetActionDetail)の更新
      await functions.getSchedulesDetailFunction(item.scheduleId);
      if (ACTION_TYPE_FLYER_SALES.includes(item.actionScheduleCode)) {
        setEditableOpen(true);
      } else {
        setOpenActRegist(true);
      }
    }
  };

  const getTooltipTxt = () => {
    let txt;
    if (item.actionScheduleCode) {
      txt = `${hourS}:${minutesS}-${hourE}:${minutesE} ${item.customerName ? ` ${item.customerName} 様` : ''} ${ACTION_TYPE[item.actionScheduleCode]}
      ${item.memo ? `、${item.memo}` : ''}`;
    } else {
      txt = `${hourS}:${minutesS}-${hourE}:${minutesE} ${item.customerName ? ` ${item.customerName} 様` : ''} ${item.customerStatusCode === 10 ? `(契)${GUIDANCE_STATUS_CODE[item.guidanceStatusCode]}` : GUIDANCE_STATUS_CODE[item.guidanceStatusCode]} ${item.userLevel ? `、${USER_LEVEL_NO[item.userLevel]}` : '、★なし'} ${item.isPairCheck ? '、揃い' : ''} ${item.siteName ? `、${item.siteName}` : ''}`;
    }
    return txt;
  };

  return (
    <>
      <NormalTooltip title={getTooltipTxt()}>
        <Rnd
          key={reset}
          className={`${classes.rnd} actionScheduleCode-${item.actionScheduleCode || '999'} customerStatusCode-${item.customerStatusCode} isResultRegister-${item.isResultRegister} ${rndHeightList[index].cnt === 0 && 'single'}`}
          default={{
            x: startX,
            y: startY,
            // width: rndWidth,
            // height: rndHeightList[index].cnt === 0 ? '39px' : '20px',
          }}
          size={{
            width: rndWidth,
            height: rndHeightList[index].cnt === 0 ? '39px' : '20px',
          }}
          // position={{
          //   x: startX,
          //   y: startY,
          // }}
          dragAxis="x"
          enableResizing={{
            top: false,
            right: true,
            bottom: false,
            left: true,
            topRight: false,
            bottomRight: false,
            bottomLeft: false,
            topLeft: false,
          }}
          bounds="parent"
          resizeGrid={[28, 0]}
          dragGrid={[28, 0]}
          minWidth="28"
          onResize={onResize}
          onResizeStop={onResizeStop}
          onDrag={onDrag}
          onDragStop={onDragStop}
          onClick={onClick}
        >
          {item.actionScheduleCode ? (
            <>
              <span className={classes.txt1}>
                {hourS}:{minutesS}-{hourE}:{minutesE}
                {item.customerName ? ` ${item.customerName} 様` : ''}
              </span>
              <span className={classes.txt2}>
                {ACTION_TYPE[item.actionScheduleCode]}
                {item.memo ? `、${item.memo}` : ''}
              </span>
            </>
          ) : (
            <>
              <span className={classes.txt1}>
                {hourS}:{minutesS}-{hourE}:{minutesE}
                {item.customerName ? ` ${item.customerName} 様` : ''}
              </span>
              <span className={classes.txt2}>
                {item.customerStatusCode === 10 ? `(契)${GUIDANCE_STATUS_CODE[item.guidanceStatusCode]}` : GUIDANCE_STATUS_CODE[item.guidanceStatusCode]}
                {item.userLevel ? `、${USER_LEVEL_NO[item.userLevel]}` : '、★なし'}
                {item.isPairCheck ? '、揃い' : ''}
                {item.siteName ? `、${item.siteName}` : ''}
              </span>
            </>
          )}
        </Rnd>
      </NormalTooltip>
      {/* GA-108 行動登録画面（源泉） */}
      {/* React 18のAutomatic Batching対応: 条件付きレンダリングにすることで、
          開くたびにコンポーネントが再マウントされ、最新のRedux stateが反映される */}
      {editableOpen && (
        <EditableWindow
          open={editableOpen}
          onClose={onCloseEditable}
          setReacquisitionFlg={setReacquisitionFlg}
          localUpdateData={localUpdateData}
          setLocalUpdateData={setLocalUpdateData}
          // OH_KDSFA-2329 編集画面には範囲外移動後の日時を渡す
          editValues={actRegistValues}
          setEditValues={setActRegistValues}
          setOpenCustomertree={setOpenCustomertree}
          actRegistFlag={Boolean(false)}
          editableFlag={Boolean(true)}
          schedulesUpdateApiFunction={functions.schedulesUpdateApiFunction}
          schedulesPostApiFunction={functions.schedulesPostApiFunction}
          schedulesDeleteApiFunction={functions.schedulesDeleteApiFunction}
        />
      )}
      {/* GA-108 行動登録画面（源泉以外） */}
      {openActRegist && (
        <ActRegistWindow
          open={openActRegist}
          onClose={onCloseActRegist}
          setReacquisitionFlg={setReacquisitionFlg}
          // OH_KDSFA-2329 範囲外移動時は移動後日時を使用する
          values={actRegistValues || localUpdateData}
          setUpdateData={actRegistValues ? setActRegistValues : setLocalUpdateData}
          setOpenCustomertree={setOpenCustomertree}
          actRegistFlag={Boolean(false)}
          editableFlag={Boolean(true)}
          targetObj={targetObj}
          setTargetObj={setTargetObj}
          archieveObj={archieveObj}
          setArchieveObj={setArchieveObj}
          selectDivision={actRegistSelectDivision}
          setSelectDivision={setActRegistSelectDivision}
          isSource={Boolean(false)}
          isEdit={Boolean(true)}
          createUpdateFunc={(obj) => {
            functions.schedulesUpdateApiFunction(item.scheduleId, obj);
          }}
          schedulesDeleteApiFunction={functions.schedulesDeleteApiFunction}
        />
      )}
      {/* GA-004 */}
      <InfoRegisterOnlyPost
        open={open2}
        onOpen={() => { setOpen2(true); }}
        onClose={onClose2}
        // newRegistrationFlgがtrueの場合、infoRegisterにguidanceIdを渡さない===新規登録になる
        guidanceId={item.guidanceId}
        // OH_KDSFA-2329 案内画面には範囲外移動後の日時を渡す
        guidanceAtValues={guidanceAtValues}
        // setClickInfoRegister={setClickInfoRegister}
        customer={item}
        // user={user}
        reacquisition={getSchedulesDate}
      />
    </>
  );
}
